import React from 'react';
import Header from '../component/template/Header';
import Footer from '../component/template/Footer';
import Tracker from '../component/tracking/tracking';

function Tracking() {
  return (
    <div>
      <Header />
      <div className="content">
        <div className="content">
        <Tracker />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Tracking;